<template>
  <v-card color="grey lighten-4" outlined light>
   <v-toolbar flat dense class="grey lighten-3 pa-0" style="width: 100%; max-width: 1200px;"> <!-- Ajuste o max-width conforme necessário -->
  <v-row no-gutters align="center" class="flex-nowrap">
    <!-- Título "Prescrição" -->
    <v-col cols="auto" class="mr-2">
      <v-toolbar-title class="text-subtitle-1 font-weight-bold">Receituário</v-toolbar-title>
    </v-col>
    <v-spacer />
    <!-- Campo de data -->

  <v-menu
    :close-on-content-click="false"
    offset-y
    open-on-hover
    dark
    open-delay="0"
    close-delay="80"
  >

    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on">
        <v-switch v-model="dataHabilitada" class="mt-0"  hide-details/>
      </div>
    </template>
    <v-card color="black" class="pa-2" min-width="250" style="opacity: 0.6; vertical-align: center;">
      <div style="font-size: 14px;">Ocultar data da prescrição.</div>
      <v-btn text small color="primary" @click="hintBtnDataPrescricao = true">Saiba mais</v-btn>
    </v-card>
  </v-menu>

    <v-icon class="mr-4" v-if="!dataHabilitada">calendar_month</v-icon>
    <v-col cols="3" sm="2" md="2" lg="2" class="pr-2"  v-else>
      <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y
        max-width="290px" min-width="auto">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field v-model="computedDateFormatted" label="Data" dense outlined
            persistent-hint prepend-icon="mdi-calendar" readonly v-bind="attrs"
            v-on="on" hide-details></v-text-field>
        </template>
        <v-date-picker v-model="date" no-title @input="menu2 = false"></v-date-picker>
      </v-menu>
    </v-col>

    <!-- Autocomplete de modelos -->
    <v-col cols="5" sm="4" md="4" lg="4" class="pr-2">
      <v-autocomplete v-model="modelo" :items="modeloReceita.modelos" :loading="isLoading" dense outlined
        hide-no-data hide-selected item-text="nome" item-value="_id" label="Buscar Modelos"
        placeholder="Digite para buscar" prepend-icon="mdi-database-search" return-object hide-details></v-autocomplete>
    </v-col>

    <!-- Botões de ação -->
    <v-col cols="auto" class="d-flex">
      <v-menu
        :close-on-content-click="false"
        offset-y
        open-on-hover
        dark
        open-delay="0"
        close-delay="80"
      >

        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
            <v-btn color="red accent-1" icon small @click="clear">
              <v-icon>mdi-broom</v-icon>
            </v-btn>
          </div>
        </template>
        <v-card color="black" class="pa-2" min-width="250" style="opacity: 0.6; vertical-align: center;">
          <div style="font-size: 14px;">Remover modelo selecionado.</div>
          <v-btn text small color="primary" @click="hintLimparSelecao = true">Saiba mais</v-btn>
        </v-card>
      </v-menu>

      <v-menu
        :close-on-content-click="false"
        offset-y
        open-on-hover
        dark
        open-delay="0"
        close-delay="80"
      >
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
            <v-btn :disabled="manualDescricao && manualDescricao.length < 8" v-if="idMedelo == null" icon small color="blue darken-1" @click="manualName = manualDescricao, dialogNovoModelo = true">
              <v-icon>mdi-note-plus</v-icon>
            </v-btn>
          </div>
        </template>
        <v-card color="black" class="pa-2" min-width="250" style="opacity: 0.6; vertical-align: center;">
          <div style="font-size: 14px;">Criar um modelo personalizado.</div>
          <v-btn text small color="primary" @click="hintBtnNovoModelo = true">Saiba mais</v-btn>
        </v-card>
      </v-menu>

      <v-menu
        :close-on-content-click="false"
        offset-y
        open-on-hover
        dark
        open-delay="0"
        close-delay="80"
      >
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
            <v-btn v-if="idMedelo != null" icon small :disabled="manualName && manualName.length < 8" color="teal darken-2" @click="dialogEditarModelo = true">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </div>
        </template>
        <v-card color="black" class="pa-2" min-width="250" style="opacity: 0.6; vertical-align: center;">
          <div style="font-size: 14px;">Editar modelo selecionado.</div>
          <!-- <v-btn text small color="primary" @click="hintBtnNovoModelo = true">Saiba mais</v-btn> -->
        </v-card>
      </v-menu>

    </v-col>
    <!--Hints botões de ação-->
    <v-dialog v-model="hintBtnDataPrescricao" max-width="500px">
      <v-card style="overflow-x:hidden;">
        <v-toolbar flat dense class="teal pa-0 white--text font-weight-bold">
          Ocultar data da prescrição.
          <v-spacer/>
          <v-btn icon @click="hintBtnDataPrescricao = false"><v-icon color="white">mdi-close</v-icon></v-btn>
        </v-toolbar>
         <v-card-text class="ma-1">
          Se esta opção estiver marcada, a data da prescrição <b>não será exibida na impressão</b>. Utilize quando desejar gerar um documento atemporal, sem referência à data.
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="hintLimparSelecao" max-width="500px" >
      <v-card style="overflow-x:hidden;">
        <v-toolbar flat dense class="teal pa-0 white--text font-weight-bold">
          Remover modelo selecionado.
          <v-spacer/>
          <v-btn icon @click="hintLimparSelecao = false"><v-icon color="white">mdi-close</v-icon></v-btn>
        </v-toolbar>
         <v-card-text class="ma-1">
          Remove a seleção do modelo atual, permitindo preencher livremente sem modelo pré-definido. Útil quando deseja criar uma prescrição ou prontuário do zero.
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="hintBtnNovoModelo" max-width="500px" >
      <v-card style="overflow-x:hidden;">
        <v-toolbar flat dense class="teal pa-0 white--text font-weight-bold">
          Criar um modelo personalizado.
          <v-spacer/>
          <v-btn icon @click="hintBtnNovoModelo = false"><v-icon color="white">mdi-close</v-icon></v-btn>
        </v-toolbar>
         <v-card-text class="ma-1">
          Permite criar um <b>novo modelo de prontuário, laudo ou prescrição</b>, que ficará disponível para uso nas próximas vezes. Isso ajuda a padronizar e acelerar os lançamentos futuros.
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</v-toolbar>
    <v-card-text>
      <v-expand-transition>
        <div v-if="inputMode === 'search'">
          <v-autocomplete
            @change="values = []"
            v-model="model"
            :items="items"
            :loading="isLoading"
            :search-input.sync="search"
            light
            hide-no-data
            hide-selected
            item-text="Description"
            item-value="API"
            label="Nome do medicamento"
            placeholder="Buscar"
            prepend-icon="mdi-database-search"
            return-object
          >
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title v-text="item.nome"></v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </div>
      </v-expand-transition>
    </v-card-text>

    <v-card flat height="580px" class="overflow-auto">
      <tiptap-vuetify
        v-model="manualDescricao"
        :card-props="{ flat: true }"
        :extensions="extensions"
        placeholder="Descrição…"
      />
    </v-card>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text dark color="red accent-1" @click="$emit('cancelar')">
        <v-icon right>mdi-close-circle</v-icon>
        Voltar
      </v-btn>
      <v-btn :disabled="!(inputMode === 'manual' ? manualDescricao : model)" color="primary" @click="cadastrarReceitaMedica">
        <span v-if="isEditarReceita">Editar</span>
        <span v-else>Adicionar</span>
        <v-icon right>mdi-check-circle-outline</v-icon>
      </v-btn>
    </v-card-actions>

    <!-- Dialog para novo modelo -->
    <v-dialog v-model="dialogNovoModelo" width="900">
      <v-card class="rounded-lg">
        <v-card-title class="text-h5 white--text primary py-4">
          <v-icon left color="white">mdi-plus-circle</v-icon>
          Cadastrar novo modelo
        </v-card-title>

        <v-card-text class="pa-6">
          <v-text-field label="Título" outlined v-model="tituloModelo"></v-text-field>
          <v-card outlined>
            <tiptap-vuetify
              v-model="manualName"
              :card-props="{ flat: true }"
              :extensions="extensions"
              placeholder="Descrição…"
            />
          </v-card>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="red lighten-1" text :loading="loadReceita" @click="dialogNovoModelo = false" class="px-4">
            <v-icon left>mdi-close-circle</v-icon>
            Cancelar
          </v-btn>
          <v-btn color="green darken-1" dark :loading="loadReceita" @click="cadastrarModeloReceituario" class="px-4"
            depressed>
            <v-icon left>mdi-content-save</v-icon>
            Cadastrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog para editar modelo -->
    <v-dialog v-model="dialogEditarModelo" width="800">
      <v-card class="rounded-lg">
        <v-card-title class="text-h5 white--text teal darken-2 py-4">
          <v-icon left color="white">mdi-pencil-circle</v-icon>
          Editar modelo
        </v-card-title>

        <v-card-text class="pa-6">
          <v-text-field label="Título" outlined v-model="tituloModelo"></v-text-field>
          <v-card outlined>
            <tiptap-vuetify
              v-model="manualName"
              :card-props="{ flat: true }"
              :extensions="extensions"
              placeholder="Descrição…"
            />
          </v-card>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="red lighten-1" text @click="dialogEditarModelo = false" class="px-4">
            <v-icon left>mdi-close-circle</v-icon>
            Cancelar
          </v-btn>
          <v-btn color="blue darken-1" dark @click="cadastrarModeloReceituario" class="px-4" depressed>
            <v-icon left>mdi-content-save-edit</v-icon>
            Salvar alterações
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import medicoService from '../../services/medico.service'
import {
  TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph,
  BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History
} from 'tiptap-vuetify'

export default {
  name: 'Receituario',
  components: { TiptapVuetify },
  props: {
    medicamentos: {
      type: Array,
      default: () => []
    },
    isEditarReceita: {
      type: Boolean,
      default: false
    },
    receitaEdit: {
      type: Object,
      default: null
    },
    ficha: {
      type: Object,
      default: null
    }
  },
  data: vm => ({
    inputMode: 'manual',
    manualName: '',
    manualDescricao: '',
    tituloModelo: '',
    attrs: {
      boilerplate: true,
      elevation: 2
    },
    descriptionLimit: 60,
    dialogNovoModelo: false,
    dialogEditarModelo: false,
    dataHabilitada: true,
    nome: '',
    hintBtnDataPrescricao: false,
    hintLimparSelecao: false,
    hintBtnNovoModelo: false,
    entries: [],
    idMedelo: null,
    dosagens: ['5mg', '10mg'],
    isLoading: false,
    loadCadastroPosologia: false,
    loadPosologia: false,
    menu2: false,
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    dateFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
    model: { nome: '' },
    modeloReceita: {},
    modeloReceituario: {},
    user: null,
    values: [],
    idReceita: null,
    modelo: null,
    search: null,
    searchModelos: null,
    loadReceita: false,
    prescricao: [],
    posologia2: '',
    extensions: [
      History, Blockquote, Link, Underline, Strike, Italic, ListItem, BulletList, OrderedList,
      [Heading, { options: { levels: [1, 2, 3] } }], Bold, Code, HorizontalRule, Paragraph, HardBreak
    ]
  }),

  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    fields () {
      if (!this.model) return []
      return Object.keys(this.model).map((key) => {
        return {
          key,
          value: this.model[key] || 'n/a'
        }
      })
    },
    items () {
      return this.entries.map((entry) => {
        const Description =
          entry.principioAtivo.length > this.nome
            ? entry.nome.slice(0, this.descriptionLimit) + '...'
            : entry.nome
        return Object.assign({}, entry, { Description })
      })
    }
  },

  methods: {
    clear () {
      this.manualName = ''
      this.modelo = null
      this.tituloModelo = ''
      this.idMedelo = null
    },

    cadastrarReceitaMedica () {
      if (this.idReceita == null) {
        this.loadReceita = true
        medicoService.medico.cadastrarReceitaMedica({
          idAtendimento: this.ficha.idAtendimento,
          idMedico: this.user.id,
          descricao: this.manualDescricao,
          dataSelecionada: this.dataHabilitada ? this.formatDate(this.date) : ''
        }).then((r) => {
          if (r.status == 200) {
            this.$emit('addReceita')
          }
        }).finally(() => {
          this.loadReceita = false
        })
      } else {
        this.loadReceita = true
        medicoService.medico.atualizarReceitaMedica({
          idReceitaMedica: this.idReceita,
          descricao: this.manualDescricao,
          dataSelecionada: this.dataHabilitada ? this.formatDate(this.date) : ''
        }).then((r) => {
          if (r.status == 200) {
            this.$emit('addReceita')
          }
        }).finally(() => {
          this.loadReceita = false
        })
      }
    },

    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    cadastrarModeloReceituario () {
      this.loadReceita = true
      const modeloReceituario = {
        idUsuario: this.user.id,
        nome: this.tituloModelo,
        descricao: this.manualName,
        _id: this.idMedelo
      }

      medicoService.medico.cadastrarModeloReceituario(modeloReceituario)
        .then((r) => {
          if (r.status == 200) {
            this.manualName = ''
            this.modelo = null
            this.tituloModelo = ''
          }
        })
        .finally(() => {
          this.loadReceita = false
          this.dialogNovoModelo = false
          this.dialogEditarModelo = false
          this.idMedelo = null
          this.buscarModelosReceituario()
        })
    },

    buscarModelosReceituario () {
      medicoService.medico.buscarModelosReceituario(this.user.id)
        .then((r) => {
          if (r.status == 200) {
            this.modeloReceita = r.data
          }
        })
    },

    listarMedicamentos (nome) {
      medicoService.medico.retornarMedicamentos(nome)
        .then((r) => {
          if (r.status == 200) {
            this.entries = r.data
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },

    salvar (data) {
      if (this.inputMode === 'manual') {
        data = {
          nome: this.manualName,
          prescricao: [],
          data: this.dataHabilitada ? this.formatDate(this.date) : '',
          principioAtivo: this.posologia2,
          obs: this.posologia2,
          isManual: true
        }
      } else {
        let values = this.values.map(v => ({
          idTipoHorarioPrescricao: v.idTipoHorarioPrescricao,
          descricao: v.descricao,
          obs: this.posologia2,
          isManual: false
        }))

        if (values.length == 0) {
          values.push({ descricao: '', obs: this.posologia2 })
        }

        data.principioAtivo = this.posologia2
        data.prescricao = values
        data.obs = this.posologia2
        data.isManual = false
      }

      if (this.isEditarReceita) {
        this.$emit('editarReceita', data)
      } else {
        this.$emit('addReceita', data)
      }
    },

    salvarPosologia () {
      this.loadCadastroPosologia = true
      const data = {
        idUsuario: this.user.id,
        posologia: {
          idMedicamento: this.model.idMedicamento,
          lista: this.values
        }
      }

      medicoService.medico.cadastrarPosologia(data)
        .finally(() => {
          this.loadCadastroPosologia = false
          this.posologia2 = ''
        })
    },

    buscarPosologia (idMedicamento) {
      this.loadPosologia = true
      medicoService.medico.retornarPosologia(this.user.id, idMedicamento)
        .then((r) => {
          if (r.status == 200) {
            this.values = r.data
          }
        })
        .finally(() => {
          this.loadPosologia = false
        })
    },

    retornarPrescricao () {
      medicoService.medico.retornarTipoHorarioPrescricao()
        .then((r) => {
          if (r.status == 200) {
            this.prescricao = r.data
          }
        })
    }
  },

  mounted () {
    this.user = this.$store.getters.usuario
    if (this.receitaEdit != null) {
      this.idReceita = this.receitaEdit.idReceitaMedica
      if (this.receitaEdit.isManual == true) {
        this.manualDescricao = this.receitaEdit.descricao
        this.posologia2 = this.receitaEdit.principioAtivo
        this.inputMode = 'manual'
      } else {
        this.model.nome = this.receitaEdit.descricao
        this.posologia2 = this.receitaEdit.principioAtivo
        this.manualDescricao = this.receitaEdit.descricao
      }
    }
    this.buscarModelosReceituario()
  },

  watch: {
    modelo (val) {
      if (val) {
        this.tituloModelo = val.nome
        this.idMedelo = val._id
        this.manualName = val.descricao
        this.manualDescricao = val.descricao
      }
    },
    search (val) {
      if (this.items.length > 0 || !val || this.isLoading) return
      this.isLoading = true
      this.listarMedicamentos(val)
    }
  }
}
</script>

<style scoped>
/* Estilos personalizados podem ser adicionados aqui */
</style>
